import React from 'react';
import styled from 'styled-components';

export default props => {
    const { data } = props;
    //console.log('EmptySpace:',data);
    return (
        <ModuleWrapper height={data.height} />
    );
}

const ModuleWrapper = styled.div`
    height: ${props => props.height};
`


// WEBPACK FOOTER //
// ./src/partials/modules/EmptySpace.js